<template>
  <div class="pages-header" :style="{'--status-bar-height':statusBarHeight}">
    <div class="pages-header__back-btn" @click="handleBack">
        <van-icon name="arrow-left" color="#000" size="17px" />
    </div>
    <div class="pages-header__title">考勤打卡</div>
    <div class="pages-header__back-btn" style="opacity: 0;"></div>
  </div>
</template>

<script>
import { Icon } from "vant";
export default {
    components: {
        [Icon.name]: Icon
    },
    props: {
        queryParams: {
            type: Object,
            default: () => ({
                fromTo: "from"
            })
        }
    },
    data(){
        return {
            statusBarHeight: ""
        }
    },
    async mounted(){
        await this.$sleep(1000);
        this.statusBarHeight = this.getStatusBarHeight() + "px";
    },
    methods:{
        handleBack(){
            window.uni.navigateBack({ 
                delta: 1
            })
        },
        isMobile(){
            return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
        },
        getStatusBarHeight() {
            // 检查是否为移动设备
            // const isMobile = /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            if (!this.isMobile()) {
                console.warn('当前设备可能不是移动设备');
                return 0;
            }

            // 尝试通过CSS变量获取状态栏高度（适用于iOS Safari）
            const iOSStatusBarHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--satatus-bar-height'));
            if (!isNaN(iOSStatusBarHeight) && iOSStatusBarHeight > 0) {
                return iOSStatusBarHeight;
            }

            // 通过视口高度与屏幕高度的差值估算状态栏高度
            const windowHeight = window.innerHeight;
            const screenHeight = screen.height;
            const statusBarHeight = screenHeight - windowHeight;

            // 检查差值是否合理（在10到100像素之间）
            if (statusBarHeight > 10 && statusBarHeight < 100) {
                return statusBarHeight;
            }

            // 默认返回常见的状态栏高度
            return /iPhone|iPad|iPod/i.test(navigator.userAgent) ? 44 : 24;
        }
    }
}
</script>

<style scoped lang="scss">
    .pages-header {
        position: fixed;
        left: 0;
        right: 0;
        top: var(--status-bar-height);
        z-index: 3000;
        height: 44px;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        overflow: hidden;
        &__back-btn {
            width: 33px;
            height: 33px;
            border-radius: 8px;
            overflow: hidden;
            box-shadow: 0px 3px 6px 1px rgba(204,181,159,0.1);
            background-color: #FFF;
            margin: 0 12px;
            display: flex;
            align-items: center;
            justify-content: center;
            &:active {
                background-color: #F5F5F5;
            }
        }
        &__title {
            font-size: 17px;
            line-height: 25px;
            color: #000000;
            text-align: center;
            font-weight: bold;

        }
    }
</style>